import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { type IndividualProduct } from "@lib/products";
import { Root as RadioGroup } from "@radix-ui/react-radio-group";
import { useRef } from "react";
import { useFormContext } from "react-hook-form";
import { ProductSwatchRadio } from "../products/product-swatch-radio";
import { type ProductSelectProps } from "./product-select-v2";
import { useSelectedShade } from "./shade-selector";

/**
 * Standard shade selector field without tabbed groups
 */
export const ShadeSelectorField = (props: ProductSelectProps) => {
  const { control } = useFormContext();
  const { product_selection: productSelect, activity } = props;

  if (
    activity.products.type === "single" ||
    activity.products.type === "bundle"
  )
    return null;

  const { layout } = productSelect;

  const products = activity.products.product.products;

  const { selectedShade } = useSelectedShade(props);

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <FormField
      control={control}
      name="order_allocation_ids"
      render={({
        field,
      }: {
        field: {
          name: string;
          value: string;
          onChange: (value: string) => void;
        };
      }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              value={field.value}
              name={field.name}
              onValueChange={(value) => {
                field.onChange(value);
              }}
              style={{
                color: productSelect.color,
                fontSize: productSelect.font_size,
              }}
              className="grid gap-2 justify-center grid-cols-swatches [&>div]:aspect-square"
            >
              {products.map((product) => (
                <ProductSwatchRadio
                  key={`all-${product.name.replace(/\s+/g, "")}`}
                  product={product as IndividualProduct}
                  selectedShade={selectedShade?.name}
                  layout={layout}
                  swatchClassName="aspect-square"
                  container={containerRef.current}
                />
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
